<p>trip-hot-list-screen works!</p>
